module.exports = __webpack_public_path__ + "img/intenselogo.e88eb467.png";